import clsx from 'clsx';

export const Progress: React.FC<{ value: number; danger?: boolean }> = (
  props
) => {
  return (
    <div className={clsx('absolute inset-0 p-1')}>
      <div
        className={clsx(
          'h-full',
          props.danger ? 'bg-red-200' : 'bg-primary-200'
        )}
        style={{
          width: `${props.value  }%`,
        }}
      />
    </div>
  );
};
